import React, { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { subRouteMapping } from "../constant/subRoutes";
import { Link, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checkcircle from "../assests/images/check-circle.png";
import { statusmappingServices } from "../services/statusmappingServices";
import { categoryServices } from "../services/categoryServices";
import { isEmptyDash } from "../constant";
import routes from "../routes";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const blockListArr = [
  {
    blockName: "Category",
    label: "Category",
    blockUrlName: "zone",
    isInput: true,
    isListAdd: true,
    isListEdit: true,
    isListRemove: true,
    list: [],
    headList: [],
  },
  {
    blockName: "Sub-Category",
    label: "Sub-Category",
    blockUrlName: "region",
    isInput: false,
    isListAdd: true,
    isListEdit: true,
    isListRemove: true,
    list: [],
    headList: [],
  },
];

function StatusMapping() {
  const [statusOpen, setstatusOpen] = React.useState(false);
  const [prioritysetupOpen, setprioritysetupOpen] = React.useState(false);
  const [newStatus, setNewStatus] = React.useState("");
  const [tatStatus, setTatStatus] = React.useState("");

  const [blockList, setBlockList] = React.useState(blockListArr);
  const [tatsetupOpen, settatsetupOpen] = React.useState(false);
  const [deleteiconopen, setdeleteiconopen] = React.useState(false);
  const [deleteprioritiessetups, setdeleteprioritiessetups] =
    React.useState(false);
  const [deletetatstatus, setdeletetatstatus] = React.useState(false);

  const [tatPrioritySelected, setTatPrioritySelected] = React.useState("");

  const [reload, setReload] = React.useState(0);
  const [statuslist, setstatuslist] = React.useState([]);
  const [prioritylist, setprioritylist] = React.useState([]);
  const [tatlist, settatlist] = React.useState([]);
  const [selectedid, setSelectedId] = React.useState("");
  const [categoryList, setCategoryList] = React.useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [configSubRoute, setConfigSubRoute] = useState([]);
  const [newpriorities, setNewPriorities] = React.useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const handleSubCategoryChange = (event) => {
    setSelectedSubCategory(event.target.value);
  };

  const [setupselectid, setSetupSelectId] = React.useState("");
  const [tatselectid, setTatSelectId] = React.useState({});

  const handleCategoryChange = (event) => {
    const selectedCategoryID = event.target.value;
    setSelectedCategory(selectedCategoryID);

    const category = categoryList?.find(
      (cat) => cat._id === selectedCategoryID
    );
    if (category) {
      setSubcategories(category.subcategories);
      setSelectedSubCategory("");
    } else {
      setSubcategories([]);
      setSelectedSubCategory("");
    }
  };

  const location = useLocation();

  useEffect(() => {
    getstatusManagements();
    getCategoryData();
    setConfigSubRoute(subRouteMapping(routes, "CONFIGURATION"));
  }, [reload]);

  const getCategoryData = () => {
    let blockListInitial = [...blockList];
    categoryServices
      .getCategoryList()
      .then((res) => {
        if (res.data.success === true) {
          setCategoryList(res.data.data);
        }
      })
      .catch(function (error) {
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
      });
  };

  const getstatusManagements = () => {
    statusmappingServices
      .getstatusManagements()
      .then((res) => {
        if (res.data.success === true) {
          let listArr = [];
          setstatuslist(res.data.data.statuses);
          res?.data?.data?.priorities?.map((ele) => {
            ele.priorityLabel = `${ele?.categoryId?.categoryName} - ${ele?.subcategoryId?.subCategoryName} - ${ele?.priority} `;
            if (isEmptyDash(ele?.tat?._id)) {
              ele.tat = { priorityId: ele?._id };
            } else {
              ele.tat.priorityId = ele?._id;
              ele.tat.priorityName = ele?.priority;
              ele.tat.tatLabel = `${ele?.priority} - ${ele.tat?.time} `;
              listArr.push(ele.tat);
            }
            // ele.tat.priorityId = ele?._id;
          });
          setprioritylist(res.data.data.priorities);
          settatlist(listArr);
        } else {
          // Handle error
        }
      })
      .catch(function (error) {
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
      });
  };
  const newStatusAPI = () => {
    statusmappingServices
      .createNewstatus(newStatus)
      .then((res) => {
        if (res.data.success === true) {
          setReload(Math.random());
        }
      })
      .catch(function (error) {
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
      });
  };
  const PrioritiesSetupAPI = () => {
    let data = {
      priority: newpriorities,
      categoryId: selectedCategory,
      subcategoryId: selectedSubCategory,
    };
    statusmappingServices
      .createPrioritiesSetup(data)
      .then((res) => {
        if (res.data.success === true) {
          setReload(Math.random());
          setSelectedCategory("");
          setSelectedSubCategory("");
          setSubcategories([]);
          setCategoryList([]);
        }
      })
      .catch(function (error) {
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
      });
  };
  const TatSetupAPI = () => {
    let data = {
      tat: tatStatus,
    };
    statusmappingServices
      .createTatSetup(data, tatPrioritySelected)
      .then((res) => {
        if (res.data.success === true) {
          setReload(Math.random());
        }
      })
      .catch(function (error) {
      })
      .finally(() => { });
  };
  const deletestatusManagementAPI = (id) => {
    statusmappingServices
      .deletestatusManagement(id)
      .then((res) => {
        if (res.data.success === true) {
          setReload(Math.random());
        }
      })
      .catch(function (error) {
      })
      .finally(() => { });
  };
  const deletesetupPrioritiesAPI = (id) => {
    statusmappingServices
      .deletesetupPriorities(id)
      .then((res) => {
        if (res.data.success === true) {
          setReload(Math.random());
        }
      })
      .catch(function (error) {
      })
      .finally(() => { });
  };
  const deletesetupTatAPI = (data) => {

    statusmappingServices
      .deletesetupTat(data?.priorityId, data?._id)
      .then((res) => {
        if (res.data.success === true) {
          setReload(Math.random());
        }
      })
      .catch(function (error) {
      })
      .finally(() => {
        setdeletetatstatus(false);
      });
  };

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div class="heading_search_outer d sub-route-upper-sec">
            <div className="sub-route-sec">
              {configSubRoute.map(
                (ele, i) =>
                  ele.isSubRoute && (
                    <div
                      style={{ padding: "5px 7px 7px" }}
                      className={
                        location.pathname.indexOf(ele.path) !== -1
                          ? "sub-route-sec-div sub-route-sec-div-active"
                          : "sub-route-sec-div"
                      }
                    >
                      <Link to={ele.layout + ele.path}>{ele.name}</Link>
                      {/* <p>Existing Vendor</p> */}
                    </div>
                  )
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="category_box">
                <div className="cat-card-ui">
                  <div className="heading_plus">
                    <h3>Status</h3>
                    <button className="plus-btn">
                      <AddIcon onClick={() => setstatusOpen(true)} />
                    </button>
                  </div>
                  {statuslist.length > 0 && (
                    <div>
                      {statuslist?.map((item) => (
                        <div className="category_listing " key={item._id}>
                          <div className="array_react_list_name">
                            {/* <input type="checkbox" /> */}
                            <span>{item?.statusName}</span>
                          </div>
                          <DeleteIcon
                            className="icon_color_electrical"
                            onClick={() => {
                              setdeleteiconopen(true);
                              setSelectedId(item._id);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  {statuslist.length < 1 && (
                    <div className="cat-card-nodata-ui">
                      <div>No Data Found</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="category_box">
                <div className="cat-card-ui">
                  <div className="heading_plus">
                    <h3>Priority Setup</h3>
                    <button className="plus-btn">
                      <AddIcon onClick={() => setprioritysetupOpen(true)} />
                    </button>
                  </div>

                  {prioritylist.length > 0 && (
                    <div>
                      {prioritylist?.map((item) => (
                        <div className="category_listing ">
                          <div className="array_react_list_name">
                            {/* <input type="checkbox" /> */}
                            <span>{item?.priorityLabel}</span>
                          </div>
                          <DeleteIcon
                            className="icon_color_electrical"
                            onClick={() => {
                              setSetupSelectId(item._id);
                              setdeleteprioritiessetups(true);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {prioritylist.length < 1 && (
                    <div className="cat-card-nodata-ui">
                      <div>No Data Found</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-sm-4">
              <div className="category_box">
                <div className="cat-card-ui">
                  <div className="heading_plus">
                    <h3>TAT Setup</h3>
                    <button className="plus-btn">
                      <AddIcon onClick={() => settatsetupOpen(true)} />
                    </button>
                  </div>

                  {tatlist.length > 0 && (
                    <div>
                      {tatlist?.map((item) => (
                        <>
                          <div className="category_listing " key={item._id}>
                            <div className="array_react_list_name">
                              {/* <input type="checkbox" /> */}
                              <span>
                                {item?.tatLabel}
                                {item?.priority}
                                {item?.subcategoryId?.subCategoryName}
                                {item?.categoryId?.categoryName}
                              </span>
                            </div>

                            <DeleteIcon
                              className="icon_color_electrical"
                              onClick={() => {
                                setTatSelectId(item);
                                setdeletetatstatus(true);
                              }}
                            />
                          </div>
                        </>
                      ))}
                    </div>
                  )}
                  {tatlist.length < 1 && (
                    <div className="cat-card-nodata-ui">
                      <div>No Data Found</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Status Modal */}
          <Modal
            open={statusOpen}
            onClose={() => setstatusOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add New Status
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setstatusOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="lets_select_smes">
                  <label className="mb-1 text-dark">
                    Enter Status Name<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="vendorName"
                    className="form-control form_h_modal"
                    fdprocessedid="uqf2v"
                    value={newStatus}
                    onChange={(e) => setNewStatus(e.target.value)}
                  />
                  <div className="error-message" id="vendorNameError"></div>
                </div>
              </div>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setstatusOpen(false);
                  }}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    setstatusOpen(false);
                    newStatusAPI();
                  }}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          {/* Priority Setup Modal */}
          <Modal
            open={prioritysetupOpen}
            onClose={() => setprioritysetupOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_creation_react_modals1 MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add New Priority Setup
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setprioritysetupOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Category <span className="required">*</span>
                    </label>

                    <select
                      id="categorySelect"
                      className="form-select lets_sub_cotegory"
                      value={selectedCategory}
                      onChange={handleCategoryChange}
                    >
                      <option value="">Select Category</option>
                      {categoryList?.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category.categoryName}
                        </option>
                      ))}
                    </select>

                    <div
                      className="error-message"
                      id="categorySelectError"
                    ></div>
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Sub Category <span className="required">*</span>
                    </label>
                    <select
                      id="categorySelect"
                      className="form-select lets_sub_cotegory"
                      value={selectedSubCategory}
                      onChange={handleSubCategoryChange}
                    >
                      <option value="">Select Subcategory</option>
                      {subcategories?.map((subcategory) => (
                        <option key={subcategory._id} value={subcategory._id}>
                          {subcategory.subCategoryName}
                        </option>
                      ))}
                    </select>

                    <div
                      className="error-message"
                      id="categorySelectError"
                    ></div>
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Priority <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="vendorName"
                      value={newpriorities}
                      onChange={(e) => setNewPriorities(e.target.value)}
                      className="form-control form_h_modal"
                      placeholder="Enter Sub-Category"
                      required=""
                    />
                    <div className="error-message" id="vendorNameError"></div>
                  </div>
                </div>
              </div>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setprioritysetupOpen(false);
                  }}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    PrioritiesSetupAPI();
                    setprioritysetupOpen(false);
                  }}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          {/* TAT Setup Modal */}
          <Modal
            open={tatsetupOpen}
            onClose={() => settatsetupOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add New TAT Setup
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => settatsetupOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Priority <span className="required">*</span>
                    </label>

                    <select
                      id="categorySelect"
                      className="form-select lets_sub_cotegory"
                      fdprocessedid="jqrnmq"
                      onChange={(e) => setTatPrioritySelected(e.target.value)}
                      value={tatPrioritySelected}
                    >
                      <option value="">Select Priority</option>
                      {prioritylist?.map((ele) => (
                        <option key={ele._id} value={ele._id}>
                          {ele.priority}
                        </option>
                      ))}
                    </select>
                    <div
                      className="error-message"
                      id="categorySelectError"
                    ></div>
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      TAT <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="vendorName"
                      className="form-control form_h_modal"
                      onChange={(e) => setTatStatus(e.target.value)}
                    />
                    <div className="error-message" id="vendorNameError"></div>
                  </div>
                </div>
              </div>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    settatsetupOpen(false);
                  }}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    settatsetupOpen(false);
                    TatSetupAPI();
                  }}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          {/* Delete Modal */}
          <Modal
            open={deleteiconopen}
            onClose={() => setdeleteiconopen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setdeleteiconopen(false)}
                ></button>
              </div>
              <div className="modal-body lets_list_cotegory_status_management_block_bodyP">
                <p className="lets_want_changes_delete_icon">
                  Do you really want to change it?
                </p>

                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={() => setdeleteiconopen(false)}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    setdeleteiconopen(false);
                    deletestatusManagementAPI(selectedid);
                  }}
                >
                  Confirm
                </Button>
              </div>
            </Box>
          </Modal>
          {/* P Setup Delete Modal */}
          <Modal
            open={deleteprioritiessetups}
            onClose={() => setdeleteprioritiessetups(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setdeleteprioritiessetups(false)}
                ></button>
              </div>
              <div className="modal-body lets_list_cotegory_status_management_block_bodyP">
                <p className="lets_want_changes_delete_icon">
                  Do you really want to change it?
                </p>

                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={() => deleteprioritiessetups(false)}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    setdeleteprioritiessetups(false);
                    deletesetupPrioritiesAPI(setupselectid);
                  }}
                >
                  Confirm
                </Button>
              </div>
            </Box>
          </Modal>
          {/* Delete TAT */}
          <Modal
            open={deletetatstatus}
            onClose={() => setdeletetatstatus(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setdeletetatstatus(false)}
                ></button>
              </div>
              <div className="modal-body lets_list_cotegory_status_management_block_bodyP">
                <p className="lets_want_changes_delete_icon">
                  Do you really want to change it?
                </p>

                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={() => setdeletetatstatus(false)}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    // setdeletetatstatus(false);
                    deletesetupTatAPI(tatselectid);
                  }}
                >
                  Confirm
                </Button>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default StatusMapping;
